export const GET_ACCOUNT_INFORMATION = "GET_ACCOUNT_INFORMATION";
export const GET_ACCOUNT_INFORMATION_LOADER = "GET_ACCOUNT_INFORMATION_LOADER";
export const GET_SECURITY_QUESTIONS = "GET_SECURITY_QUESTIONS";
export const GET_IS_IDF_USER = "GET_IS_IDF_USER";
export const SET_IS_IDF_USER_LOADER = "SET_IS_IDF_USER_LOADER";
export const GET_FAMILY_OFFER = "GET_FAMILY_OFFER";
export const SET_FAMILY_OFFER_LOADER = "SET_FAMILY_OFFER_LOADER";
export const SET_IS_BILLING_INFO_CHANGED = "SET_IS_BILLING_INFO_CHANGED";

export interface ImyAccountState {
    _unifiedAccountInfo?: _unifiedAccountInfo;
    isLoading: boolean;
    securityQueData?: any;
    isIdfUser?: boolean;
    isIdfUserLoading: boolean;
    familtOffer?: IfamilyOffer;
    isLoadingFamilyOffer: boolean;
    isBillingInfoChanged: boolean;
}

export interface _unifiedAccountInfo {
    firstName?: string;
    lastName?: string;
    middleInitial?: string;
    generationSuffix?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    phone?: string;
    email?: string;
    preferredCom?: string;
    // memberShipNumber?: string;
    accountCreationDate?: string;
    businessname?: string;
    fax?: string;
    // ein?: string;
    country?: string;
    personalSMS?: string;
    isSSOUser?: boolean;
    caseId?: string;
    isIDFRevwireUser?: boolean;
    _personalAccountInformation?: _personalAccountInformation;
    _twoFactorAuthentication?: _twoFactorAuthentication;
    _familyProtection?: _familyProtection;
    _contactPreference?: _contactPreference;
    _passwordSecurity?: _passwordSecurity;
    _businessInformation?: _businessInformation;
    _languagePreference: _languagePreference;
    isLegacyIDFWrittenAccepted: string;
}

export interface _personalAccountInformation {
    firstName?: string;
    lastName?: string;
    middleInitial?: string;
    primaryEmail?: string;
    primaryPhone?: string;
    userName?: string;
}

export interface _businessInformation {
    businessName?: string;
    // ein?: string;
    fax?: string;
    numberOfEmployees?: string;
}

export interface _twoFactorAuthentication {
    twoFactorAuth?: boolean;
    primaryEmail?: string;
    mfaSMSNumber?: string;
    mfaVoiceCallNumber?: string;
}

export interface _familyProtection {
    _familyProtectionChildrens?: [];
}

export interface _languagePreference {
    code: string;
    description: string;
    displayName: string;
    id: number;
}

export interface _contactPreference {
    email?: string;
    smsNumber?: string;
    alertNotification?: boolean;
    idCrimeAndBreachNews?: boolean;
    appPushNotification?: boolean;
    textSMSNotification?: boolean;
}

export interface _passwordSecurity {
    lastPasswordChangeDate?: string;
}

export interface IfamilyOffer {
    familyAdultOffer?: IfamilyAdultOffer;
    familyChildOffer?: IfamilyChildOffer;
}

export interface IfamilyAdultOffer {
    adultIdfOfferId?: string;
    adultMaxLimit?: number;
    adultPackageCode?: string;
    hasAdultOffer?: boolean;
    hasIdfOffer?: boolean;
    hasCustomPrice?: boolean;
    isUserPaid?: boolean;
    payAsYouGoAnnualPrice?: number;
    payAsYouGoMonthlyPrice?: number;
}

export interface IfamilyChildOffer {
    childIdfOfferId?: string;
    childAgeLimit?: number;
    childMaxLimit?: number;
    childPackageCode?: string;
    hasChildOffer?: boolean;
    hasIdfOffer?: boolean;
}

export interface getAccountInformationAction {
    type: "GET_ACCOUNT_INFORMATION";
    _unifiedAccountInfo: _unifiedAccountInfo;
}

export interface getAccountInformationLoader {
    type: "GET_ACCOUNT_INFORMATION_LOADER";
    isLoading: boolean;
}

export interface getSecurityQuestionsAction {
    type: "GET_SECURITY_QUESTIONS";
    securityQueData: any;
}

export interface getisIdfUserAction {
    type: "GET_IS_IDF_USER";
    isIdfUser: boolean;
}

export interface setisIdfUserLoader {
    type: "SET_IS_IDF_USER_LOADER";
    isIdfUserLoading: boolean;
}

export interface getFamilyOffer {
    type: "GET_FAMILY_OFFER";
    familyOffer: IfamilyOffer;
}

export interface setFamilyOfferLoader {
    type: "SET_FAMILY_OFFER_LOADER";
    isLoadingFamilyOffer: boolean;
}

export interface setIsBillingInfoChanged {
    type: "SET_IS_BILLING_INFO_CHANGED";
    isBillingInfoChanged: boolean;
}

export type KnownAction =
    | getAccountInformationAction
    | getAccountInformationLoader
    | getSecurityQuestionsAction
    | getisIdfUserAction
    | setisIdfUserLoader
    | getFamilyOffer
    | setFamilyOfferLoader
    | setIsBillingInfoChanged;
